import { CalendarToday, Edit } from '@mui/icons-material';
import { Grid, Box, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ProcessStep } from '../../common/enums/enums';
import {
  assignTextOnLoading,
  estimatedTimeCompletion,
} from '../../helpers/orders';
import GenDataText from '../GenDataText';
import StatusButton from '../StatusButton';
import { WOrderModalEditCompletionTime } from './WOrderModalEditCompletionTime';

const WOrderStatus = ({
  data,
  isLoading,
  isLoadingEditCompletion,
  onChangeCompletionTime,
}) => {
  const { t } = useTranslation('workOrdersTable');
  const [editCompletionOpen, setEditCompletionOpen] = useState(false);

  useEffect(() => {
    if (isLoadingEditCompletion) return;
    setEditCompletionOpen(false);
  }, [isLoadingEditCompletion]);

  const closeModal = () => {
    setEditCompletionOpen(false);
  };

  const isAbleToEditDate = () =>
    [
      ProcessStep.GENERATED,
      ProcessStep.APPROVED,
      ProcessStep.IN_TRANSIT,
      ProcessStep.ARRIVED,
      ProcessStep.PAUSED,
      ProcessStep.IN_PROCESS,
    ].includes(data?.step);

  const getPromiseDate = () => {
    return data?.promiseDate || estimatedTimeCompletion(data);
  };

  return (
    <>
      <WOrderModalEditCompletionTime
        data={data}
        isLoading={isLoadingEditCompletion}
        open={editCompletionOpen}
        onCancel={closeModal}
        onChangeCompletionTime={onChangeCompletionTime}
      />
      <Box
        sx={{
          bgcolor: 'background.paper',
          p: { xs: 2, sm: 2, lg: 4 },
          borderTop: '1px solid',
          borderColor: theme => theme.palette.divider,
        }}
      >
        <Grid container>
          <Grid item xs={6} sm={6} md={3}>
            <Grid container flexDirection="row">
              <GenDataText
                label={t('detail.statusRow.ownerLabel')}
                text={assignTextOnLoading(
                  [data?.owner?.firstName, data?.owner?.lastName]
                    .filter(x => x)
                    .join(' '),
                  isLoading
                )}
                direction="vertical"
                alignItems="start"
              />
            </Grid>
          </Grid>
          <Grid item xs={6} sm={6} md={3}>
            <Grid container flexDirection="row">
              <Grid item>
                <StatusButton
                  title={true}
                  status={data?.status}
                  isLoading={isLoading}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={6} pt={{ xs: 2, sm: 2, md: 0 }}>
            <Grid container flexDirection={{ xs: 'row', sm: 'row' }}>
              <Grid item xs={6} sm={6}>
                <Grid container flexDirection="row">
                  <Grid item sx={{ width: { xs: '120px', sm: 'auto' } }}>
                    <GenDataText
                      label={t('detail.statusRow.oderPlacedLabel')}
                      text={assignTextOnLoading(data?.date, isLoading)}
                      direction="vertical"
                      alignItems="start"
                      date={true}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={4} sm={4}>
                <Grid container flexDirection="row">
                  {data?.promiseDate && (
                    <Grid item display="flex" data-testid="calendar">
                      <CalendarToday color="info" />
                    </Grid>
                  )}
                  <Grid item sx={{ width: { xs: '120px', sm: 'auto' } }}>
                    <GenDataText
                      label={t('detail.statusRow.promiseDateLabel')}
                      text={assignTextOnLoading(getPromiseDate(), isLoading)}
                      direction="vertical"
                      alignItems="start"
                      date={true}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={2} sm={2}>
                {isAbleToEditDate() && (
                  <Grid
                    item
                    justifyContent="flex-end"
                    display="flex"
                    marginLeft="auto"
                    data-testid="edit-button"
                  >
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => setEditCompletionOpen(true)}
                      sx={{
                        minWidth: 34,
                        p: 0.75,
                        color: theme => theme.palette.text.secondary,
                        borderColor: theme => theme.palette.divider,
                      }}
                    >
                      <Edit fontSize="small" />
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default WOrderStatus;
